module.exports = __webpack_public_path__ + "img/01-memu-bar.56d66cb7.png";